import * as types from '../actions/types'
import Immutable from 'immutable'


import {
    isPrimitive,
    adjunto,
    factura,
    enums
} from '../utils/helpers'

const INITIAL_STATE = Immutable.fromJS({
    user: null,
    message: null,
    msgBox: {
        show: false,
        message: null
    },
    expanded: null,
    modalSelector: {
        show: false,
        title: '',
        url: '',
        fields: [],
        data: [],
        action: null,
        filter: '',
        pages: [],
        showRecords: 100,
        customFilters: []
    },
    modalSelectorAirport: {
        show: false,
        title: '',
        url: '',
        fields: [],
        data: [],
        action: null,
        filter: '',
        pages: [],
        showRecords: 100,
        customFilters: [],
        isLoading: false
    },
    parametros: {},
	modalDelete: {
		show: false,
		action: null,
		message: null
    },
	modalConfirmarAccion: {
		show: false,
		action: null,
        message: null,
        hasChildren: false
    },
    modalAddFile: {
        show: false,
        title: '',
        data: null,
        btnDisabled: false,
        index: null
    },
    modalAddChat: {
        show: false,
        title: '',
        data: null,
        btnDisabled: false,
        index: null
    },
    modalAddFactura: {
        show: false,
        data: null,
        unchanged: null,
        url: null,
        type: null,
        saldo: 0,
        btnDisabled: false
    },
    modalLastFactura: {
        show: false,
        action: null
    },
    modalAddVerificacionSOMA: {
        show: false,
        data: null,
        unchanged: null,
        url: null,
        type: null
    },
    modalCreateOtrosi: {
        show: false,
        message: ''
    },
    enums: {},
    searchingAirports: false,
})

export default function (state = INITIAL_STATE, action) {
    let data, index
    switch (action.type) {
        case types.ASIGNAR_USUARIO_SESION:
            state = state.set('user', Immutable.fromJS(action.payload.usuario))
            data = enums
            data.documentos.tipos = action.payload.documentos.reduce((a, b) => {
                a[b.CODIGO] = b
                return a
            }, {})

            Object.keys(data.solicitudes.tipos).forEach(tipo => {
                const solicitud = action.payload.solicitudes.filter(solicitud => solicitud.TIPO_SOLICITUD == tipo)[0]
                if (solicitud) {
                    data.solicitudes.tipos[tipo].responsable = solicitud['USUARIO']
                }
            })

            state = state.set('enums', Immutable.fromJS(data))
            return state
        case types.MOSTRAR_MENSAJE:
            state = state.set('message', Immutable.fromJS(action.payload))
            return state
        case types.LIMPIAR_MENSAJES:
            state = state.set('message', null)
            return state
        case types.MOSTRAR_MODAL_ERROR:
            state = state.setIn(['msgBox', 'show'], action.payload.show)
            state = state.setIn(['msgBox', 'message'], action.payload.message)
            return state
        case types.EXPANDIR_CONTRAER_MODULO:
            state = state.set('expanded', action.payload)
            return state

        case types.MOSTRAR_MODAL_SELECTOR:
            state = state.setIn(['modalSelector', 'show'], true)
            state = state.setIn(['modalSelector', 'title'], action.payload.title)
            state = state.setIn(['modalSelector', 'url'], action.payload.url)
            state = state.setIn(['modalSelector', 'fields'], Immutable.fromJS(action.payload.fields))
            state = state.setIn(['modalSelector', 'action'], action.payload.action)
            return state
        case types.OCULTAR_MODAL_SELECTOR:
            state = state.set('modalSelector', INITIAL_STATE.get('modalSelector'))
            return state
        case types.MODIFICAR_CRITERIO_FILTRADO_MODAL_SELECTOR:
            state = state.setIn(['modalSelector', 'filter'], action.payload)
            return state
        case types.MODIFICAR_PAGINA_MODAL_SELECTOR:
            state = state.setIn(['modalSelector', 'pages'], state.getIn(['modalSelector', 'pages']).concat(action.payload.page))
            return state
        case types.REINICIAR_LISTA_MODAL_SELECTOR:
            state = state.setIn(['modalSelector', 'pages'], Immutable.fromJS([]))
            state = state.setIn(['modalSelector', 'data'], Immutable.fromJS([]))
            return state
        case types.ACTUALIZAR_LISTADO_SELECTOR:
            state = state.setIn(['modalSelector', 'data'], state.getIn(['modalSelector', 'data']).concat(Immutable.fromJS(action.payload.list)))
            return state


        case types.MOSTRAR_MODAL_SELECTOR_AIRPORT:
            state = state.setIn(['modalSelectorAirport', 'show'], true)
            state = state.setIn(['modalSelectorAirport', 'title'], action.payload.title)
            state = state.setIn(['modalSelectorAirport', 'url'], action.payload.url)
            state = state.setIn(['modalSelectorAirport', 'fields'], Immutable.fromJS(action.payload.fields))
            state = state.setIn(['modalSelectorAirport', 'action'], action.payload.action)
            
            return state
        case types.OCULTAR_MODAL_SELECTOR_AIRPORT:
            state = state.set('modalSelectorAirport', INITIAL_STATE.get('modalSelectorAirport'))
            return state
        case types.MODIFICAR_CRITERIO_FILTRADO_MODAL_SELECTOR_AIRPORT:
            state = state.setIn(['modalSelectorAirport', 'filter'], action.payload)
            return state
        case types.MODIFICAR_PAGINA_MODAL_SELECTOR_AIRPORT:
            state = state.setIn(['modalSelectorAirport', 'pages'], state.getIn(['modalSelectorAirport', 'pages']).concat(action.payload.page))
            return state
        case types.REINICIAR_LISTA_MODAL_SELECTOR_AIRPORT:
            state = state.setIn(['modalSelectorAirport', 'data'], Immutable.fromJS([]))
            return state
        case types.ACTUALIZAR_LISTADO_SELECTOR_AIRPORT:
            state = state.setIn(['modalSelectorAirport', 'data'], state.getIn(['modalSelectorAirport', 'data']).concat(Immutable.fromJS(action.payload.list)))
            return state            
        case types.ACTUALIZAR_STORE_PARAMETROS:
            state = state.setIn(['parametros', action.payload.param], Immutable.fromJS(action.payload.data));
            return state
		case types.MOSTRAR_OCULTAR_MODAL_CONFIRMAR_ACCION:
			state = state.setIn(['modalDelete', 'show'], action.payload.open)
			state = state.setIn(['modalDelete', 'action'], action.payload.action)
			state = state.setIn(['modalDelete', 'message'], action.payload.message)
            return state
            
		case types.MODAL_CONFIRMAR_ACCION:
			state = state.setIn(['modalConfirmarAccion', 'show'], action.payload.open)
			state = state.setIn(['modalConfirmarAccion', 'action'], action.payload.action)
            state = state.setIn(['modalConfirmarAccion', 'message'], action.payload.message)
            state = state.setIn(['modalConfirmarAccion', 'hasChildren'], action.payload.hasChildren)
			return state

        case types.ADICIONAR_FILTRO_MODAL_SELECTOR:
			state = state.updateIn(['modalSelector', 'customFilters'], list => list.push(Immutable.fromJS(action.payload)))
            return state


        case types.MOSTRAR_MODAL_AGREGAR_ARCHIVO:        
            state = state.setIn(['modalAddFile', 'title'], action.payload.title)
            state = state.setIn(['modalAddFile', 'show'], action.payload.show)
            state = state.setIn(['modalAddFile', 'index'], action.payload.index)

            data = Immutable.fromJS(adjunto())
            if (action.payload.mode === 'edit') data = action.payload.file
            state = state.setIn(['modalAddFile', 'data'], data)
            return state

        case types.OCULTAR_MODAL_AGREGAR_ARCHIVO:
            state = state.set('modalAddFile', INITIAL_STATE.get('modalAddFile'))
            return state

        case types.MODIFICAR_INPUTS_COMMON_REDUCER:
            if (isPrimitive(action.payload.value)) {
    			state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
            } else {
                if (action.payload.immutable === false) {
                    state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
                } else {
                    state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value))
                }
            }            
            return state

            
        case types.MOSTRAR_MODAL_ADICIONA_FACTURA:
            if (action.payload.show) {
                state = state.setIn(['modalAddFactura', 'show'], true)
                state = state.setIn(['modalAddFactura', 'data'], Immutable.fromJS(factura(action.payload.documento.get('id'))))
                state = state.setIn(['modalAddFactura', 'data', 'documento'], action.payload.documento)
                state = state.setIn(['modalAddFactura', 'unchanged'], Immutable.fromJS(factura(null)))
                state = state.setIn(['modalAddFactura', 'url'], action.payload.url)
                state = state.setIn(['modalAddFactura', 'type'], action.payload.type)
                state = state.setIn(['modalAddFactura', 'saldo'], action.payload.saldo)
                state = state.setIn(['modalAddFactura','btnDisabled'],false)
            } else {
                state = state.set('modalAddFactura', INITIAL_STATE.get('modalAddFactura'))
                state = state.setIn(['modalAddFactura','btnDisabled'],false)
            }
            return state

            
		case types.MOSTRAR_MODAL_ULTIMA_FACTURA:
			state = state.setIn(['modalLastFactura', 'show'], action.payload.show)
			state = state.setIn(['modalLastFactura', 'action'], action.payload.action)
            state = state.setIn(['modalAddFactura','btnDisabled'],true)
            return state
            

        case types.MOSTRAR_MODAL_ADICION_VERIFICACION_SST:
            if (action.payload.show) {
                state = state.setIn(['modalAddVerificacionSOMA', 'show'], true)
                state = state.setIn(['modalAddVerificacionSOMA', 'data'], action.payload.verificacion)
                state = state.setIn(['modalAddVerificacionSOMA', 'unchanged'], action.payload.verificacion)
                state = state.setIn(['modalAddVerificacionSOMA', 'url'], action.payload.url)
                state = state.setIn(['modalAddVerificacionSOMA', 'type'], action.payload.type)
            } else {
                state = state.set('modalAddVerificacionSOMA', INITIAL_STATE.get('modalAddVerificacionSOMA'))
            }
            return state


		case types.MOSTRAR_MODAL_CREATE_OTROSI:
            state = state.setIn(['modalCreateOtrosi', 'show'], action.payload.show)
            state = state.setIn(['modalCreateOtrosi', 'message'], action.payload.message)
			return state

        case types.SEARCHING_AIRPORTS:
            console.log('SEARCHING_AIRPORTS', action.payload)
            state = state.setIn(['modalSelectorAirport', 'isLoading'], action.payload)
            return state


        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/common.js